import { EmptyState, Table } from '@dixa/lib-shared-habla';

export const ConversationsTableEmptyRow = (): JSX.Element => {
  return (
    <Table.Tr>
      <Table.Td colSpan={100}>
        <EmptyState
          title="No conversations match the criteria"
          description="Try changing or resetting filters"
          size="large"
          icon="url-trigger"
        />
      </Table.Td>
    </Table.Tr>
  );
};
